export const parseDateFormat = (date: string, timezone: string | null, withTime: boolean = true) => {
  let dateObject = new Date(date)
  if (!isNaN(dateObject.getTime())) {
    let options: any = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }
    if (withTime) {
      options.hour = '2-digit'
      options.minute = '2-digit'
      options.second = '2-digit'
    }
    if (timezone) {
      options.timeZone = timezone
    }
    let formatDate = new Intl.DateTimeFormat('es', options)
    return formatDate.format(dateObject)
  }
  return null
}
